module.exports = __webpack_public_path__ + "static/images/cancelled.1xTJqNF.svg";